import axios from 'axios';
import router from '@/router';
import params from '@/config/params';

const urlMain = params.apiDomain + 'menu-list';

export default {
    state: {
        list: [],
    },
    getters: {
        menuList: state => state.list || [],
    },
    mutations: {
        menu_set(state, list = []) {
            state.list = list.map(name => router.resolve({ name }).route);
        },
        menu_clear(state) {
            state.list = [];
        },
    },
    actions: {
        setMenu({ commit }, isMobile) {
            return new Promise((resolve, reject) => {
                axios({
                    url: urlMain,
                    method: 'GET',
                })
                    .then(resp => {
                        if (isMobile) {
                            const mobileMenuList =
                                resp.data.filter(name => name !== 'ActualIssueDelivery')
                                    .map(name => {
                                        if (name === 'RefundIndex') {
                                            return 'ReturnFromKuperVitrina';
                                        } else {
                                            return name;
                                        }
                                    });

                            commit('menu_set', mobileMenuList);
                        } else {
                            commit('menu_set', resp.data);
                        }

                        resolve(resp);
                    })
                    .catch(err => {
                        commit('menu_clear');
                        reject(err);
                    });
            });
        },
    },
};